import React from "react";
import PrimaryButton from "../buttons/PrimaryButton";

type ConfirmModalProps = {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmModal = ({ message, onConfirm, onCancel }: ConfirmModalProps) => {
  return (
    <div className="popup-confirm-overlay">
      <div className="popup-confirm-content">
        <p className="popup-confirm-title">確認</p>
        <p className="popup-confirm-text">{message}</p>
        <PrimaryButton className="popup-confirm-yes-btn" onClick={onConfirm}>
          はい
        </PrimaryButton>
        <PrimaryButton className="popup-confirm-no-btn" onClick={onCancel}>
          いいえ
        </PrimaryButton>
      </div>
    </div>
  );
};

export default ConfirmModal;